module.exports = __webpack_public_path__ + "img/160.7b13a6a3.jpg";